import { Nav } from "@/components/site/Nav";
import { Marquee } from "@/components/site/Marquee";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { ProstaHero } from "@/components/prosta/ProstaHero";
import { ProstaWhy } from "@/components/prosta/ProstaWhy";
import { ProstaIngredients } from "@/components/prosta/ProstaIngredients";
import { ProstaPricing } from "@/components/prosta/ProstaPricing";

const LINKS = [["Why", "#why"], ["Ingredients", "#ingredients"], ["Offer", "#offer"], ["FAQ", "#faq"]];
const MARQUEE = ["Boron", "Tongkat Ali", "Ashwagandha", "Fenugreek", "Panax Ginseng", "Maca Root", "Artichoke", "Nettle Root", "Zinc", "Magnesium", "Vitamin D"];
const QA = [
  ["What is ProstaVive?", "A powdered dietary supplement for men, made with nutrients the maker says support prostate health, blood flow, urine flow, sleep and energy."],
  ["How do I take it?", "The maker describes it as one scoop mixed into one glass a day. Follow the directions on the label."],
  ["What are the key ingredients?", "Boron, Tongkat Ali, Ashwagandha, Fenugreek, Panax Ginseng, Maca Root, Artichoke Extract and Nettle Root, plus Zinc, Magnesium and Vitamin D."],
  ["How much does it cost?", "On the official site: 1 bottle $79, 3 bottles $59 each ($177), 6 bottles $39 each ($234). The 3 and 6 bottle packs include 2 free bonus guides. Confirm at checkout."],
  ["Is there a money-back guarantee?", "Please read the refund policy on the official ProstaVive order page before buying."],
  ["Is it right for me?", "If you take medication, have a medical condition or urinary symptoms, talk to your doctor before using it."],
];
const HEADLINE = <>Your health, <span className="font-serif italic font-normal text-[#00AEEF]">your call.</span></>;

export default function ProstaVive() {
  return (
    <main className="bg-[#071E33]" data-testid="prostavive-page">
      <Nav product="prostavive" links={LINKS} />
      <ProstaHero />
      <Marquee items={MARQUEE} dot="#00AEEF" />
      <ProstaWhy />
      <ProstaIngredients />
      <ProstaPricing />
      <Faq items={QA} />
      <Footer product="prostavive" headline={HEADLINE} />
    </main>
  );
}
